import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <section id="about" className="about-us-section">
      <h2 className="about-us-heading">About Us</h2>
      <div className="about-us-all">
      <div className="about-us-item">
        <p>
          Kyokushin Karate South Australia is dedicated to teaching the traditional art of Kyokushin Karate. Our experienced instructors are committed to helping students of all ages and skill levels achieve their full potential.
        </p>
      </div>

      <div className="about-us-philosophy">
        <h3 className="about-us-subheading">Our Philosophy</h3>
        <ul className="about-us-list">
          <li>Discipline: Develop self-control and respect</li>
          <li>Strength: Build both physical and mental strength</li>
          <li>Confidence: Boost self-esteem through achievement</li>
          <li>Community: Foster a supportive and inclusive environment</li>
        </ul>
      </div>
      </div>
    </section>
  );
};

export default AboutUs;
